
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFilter4Off as ObiFilter4OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-filter-4-off.js';
 
 
 

 
 export const ObiFilter4Off = createComponent({
   react: React,
   tagName: 'obi-filter-4-off',
   elementClass: ObiFilter4OffElement,
   events: {
     
   }
  });
 
 